export default __webpack_public_path__ + "static/media/bootstrap.c5dedb53.png";